import { Actions, IAction } from "./types";

export class Action implements IAction {
    public Type: Actions;
    public Payload: [string, any];

    constructor(type: Actions, payload: [string, any]) {
        this.Type = type;
        this.Payload = payload;
    }
} 



// WEBPACK FOOTER //
// ./src/global/Action.ts